<template>
  <v-app>
    <v-main>
      <v-bottom-navigation :value="value" color="teal" grow>
        <v-btn @click="visit = false">
          <span>Задания</span>
          <v-icon>mdi-briefcase-check</v-icon>
        </v-btn>

        <v-btn @click="getObjs">
          <span @click="visit = true">Посещение точки</span>
          <v-icon>mdi-map-marker</v-icon>
        </v-btn>
      </v-bottom-navigation>
      <v-container fluid>
        <v-row v-if="loadingStart">
          <v-col align="center">
            <v-progress-circular
              :rotate="360"
              :size="300"
              :width="35"
              color="teal"
              indeterminate
            >
            </v-progress-circular>
          </v-col>
        </v-row>
        <template v-else>
          <v-container v-if="visit">
            <v-row v-if="loading" class="ma-1 pa-1">
              <v-col align="center">
                <v-progress-circular
                  :rotate="360"
                  :size="300"
                  :width="35"
                  color="teal"
                  :value="loadingValue"
                  v-if="loading"
                >
                  {{ loadingValue }}
                </v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-else class="ma-1 pa-1">
              <v-col cols="12" class="ma-2 pa-2">
                <v-autocomplete
                  style="overflow-wrap: break-word"
                  v-model="objID"
                  :items="objs"
                  item-text="TITLE"
                  item-value="ID"
                  label="Выберите точку"
                  @keyup="selectObj"
                  outlined
                  dense
                >
                  <template v-slot:item="{ item }">
                    {{ item.TITLE }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <Blank
                  :objs="objs"
                  :objID="objID"
                  :machines="machines"
                  :completeMachines="completeMachines"
                  :recipes="recipes"
                  :equips="equips"
                  :brands="brands"
                  :models="models"
                  v-model="item"
                  :url="url"
                  :auth="auth"
                  :domen="domen"
                />
              </v-col>
            </v-row>
            <v-row v-if="item">
              <v-col>
                <template>
                  <v-autocomplete
                    class="ma-2 pa-2"
                    v-model="item.machineID"
                    label="Наименование кофемашины"
                    :items="completeMachines"
                    :disabled="item.disabled"
                    item-text="TITLE"
                    item-value="ID"
                    :filter="filterMachine"
                    outlined
                    dense
                  ></v-autocomplete>
                  <template v-if="item.btns.length > 0">
                    <template v-for="(btn, index) in item.btns">
                      <div
                        style="flex-direction: row; display: flex"
                        :key="index + '/' + 'div'"
                      >
                        <v-text-field
                          :key="index + '/' + 'btnNumber'"
                          class="ma-2 pa-2"
                          v-model="btn.number"
                          label="Кнопка"
                          type="number"
                          outlined
                          dense
                          :disabled="item.disabled"
                        ></v-text-field>
                        <v-autocomplete
                          :key="index + '/' + 'btnRecipe'"
                          class="ma-2 pa-2"
                          v-model="btn.recipeID"
                          label="Рецептура"
                          :items="recipes"
                          item-text="NAME"
                          item-value="ID"
                          outlined
                          dense
                          :disabled="item.disabled"
                        ></v-autocomplete>
                        <v-text-field
                          :key="index + '/' + 'quntity'"
                          class="ma-2 pa-2"
                          v-model="btn.cups"
                          label="Кол-во чашек"
                          :disabled="item.disabled"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </div>
                    </template>
                  </template>
                  <template v-if="item.equips.length > 0">
                    <template v-for="(equip, indexEquip) in item.equips">
                      <div
                        style="
                          flex-direction: row;
                          display: flex;
                          align-items: baseline;
                        "
                        :key="indexEquip + '/' + 'Equip/div'"
                      >
                        <v-col class="ma-2 pa-2" cols="8">
                          <v-autocomplete
                            style="font-size: 10px"
                            :key="indexEquip + '/' + 'equips/remove'"
                            v-model="equip.ID"
                            label="Доп. оборудование"
                            :items="equips"
                            item-text="TITLE"
                            item-value="ID"
                            :disabled="item.disabled"
                            outlined
                            dense
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col class="ma-2 pa-2">
                          <v-text-field
                            v-model="equip.count"
                            label="кол-во"
                            :disabled="item.disabled"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                      </div>
                    </template>
                  </template>
                </template>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-else fluid>
            <Process
              :url="url"
              :auth="auth"
              :domen="domen"
              :brands="brands"
              :models="models"
              :recipes="recipes"
            />
          </v-container>
        </template>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Blank from "@/components/Blank.vue";
import Process from "@/components/Process";
import axios from "axios";
import { BX24 } from "bx24";

export default {
  name: "App",
  components: {
    Blank,
    Process,
  },
  data: () => ({
    changeWindow: false,
    item: null,
    machines: [],
    completeMachines: [],
    recipes: [],
    equips: [],
    brands: {
      97: "Rheavendors",
      99: "Necta",
      101: "Kaffit",
      103: "Philips",
      189: "NUOVA SIMONELLI",
    },
    models: {
      187: "K95L",
      107: "XS",
      109: "XX-OC",
      111: "Calibri",
      113: "Koro",
      115: "Krea",
      117: "Nizza",
      119: "PRO",
      121: "Philips",
      143: "Saeco",
      145: "Термокружка",
      147: "Холодильник",
      149: "Вывеска",
      191: "APPIA 1GR",
      193: "APPIA 2GR",
      195: "Cool Mix",
      197: "BL Grande Pro",
      199: "BL eC",
      211: "К96L",
      213: "Терминал",
    },
    disable: false,
    loading: false,
    loadingStart: false,
    interval: {},
    loadingValue: 0,
    value: 1,
    visit: false,
    tasks: false,
    items: [],
    search: "",
    objID: "",
    timerID: "",
    objs: [],
    urlAdmin: "https://dcoffee.bitrix24.ru/rest/10991/ljc1vj4mzg7sv7tp/",
    url: "https://dcoffee.bitrix24.ru/rest/10991/ljc1vj4mzg7sv7tp/",
    auth: "",
    domen: "",
  }),
  methods: {
    async getMachines() {
      try {
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: 29,
          start: 0,
          auth: this.auth.ACCESS_TOKEN,
        };
        let isTrue = true;
        while (isTrue) {
          const list = await axios.post(this.url + "lists.element.get", params);
          //console.log({ list });
          for (const elem of list.data.result) {
            const machineSerial = elem.PROPERTY_133
              ? Object.values(elem.PROPERTY_133)[0]
              : "";
            const machineModel = elem.PROPERTY_107
              ? this.models[Object.values(elem.PROPERTY_107)[0]]
              : "";
            const machineBrand = elem.PROPERTY_103
              ? this.brands[Object.values(elem.PROPERTY_103)[0]]
              : "";
            elem.title = elem.TITLE;
            elem.TITLE = `${machineSerial}/${machineModel}/${machineBrand}`;

            if (elem.PROPERTY_639) {
              if (Object.values(elem.PROPERTY_639) != "215") {
                this.machines.push(elem);
              } else {
                this.completeMachines.push(elem);
              }
            } else {
              this.machines.push(elem);
            }
          }
          if (list.data.next) params.start = list.data.next;
          else isTrue = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getMachine(item) {
      try {
        const machineParams = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "29",
          ELEMENT_ID: item.machineID,
          auth: this.auth.ACCESS_TOKEN,
        };
        const selectMachine = await axios.post(
          this.url + "lists.element.get",
          machineParams
        );
        item.machineSerial = selectMachine.data.result[0].PROPERTY_133
          ? Object.values(selectMachine.data.result[0].PROPERTY_133)[0]
          : "";
        item.machineModel = selectMachine.data.result[0].PROPERTY_107
          ? this.models[
              Object.values(selectMachine.data.result[0].PROPERTY_107)[0]
            ]
          : "";
        item.machineBrand = selectMachine.data.result[0].PROPERTY_103
          ? this.brands[
              Object.values(selectMachine.data.result[0].PROPERTY_103)[0]
            ]
          : "";
        if (item.action === "Установка") {
          const paramsBtn = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: 153,
            FILTER: {
              PROPERTY_615: item.machineID,
            },
            start: 0,
            auth: this.auth.ACCESS_TOKEN,
          };
          let isTrue = true;
          const btns = [];
          while (isTrue) {
            const listBtn = await axios.post(
              this.url + "lists.element.get",
              paramsBtn
            );
            btns.push(...listBtn.data.result);
            if (listBtn.data.next) paramsBtn.start = listBtn.data.next;
            else isTrue = false;
          }
          if (btns.length > 0) {
            for (const btn of btns) {
              item.btns.push({
                id: btn.ID,
                number: Object.values(btn.PROPERTY_609)[0],
                recipeID: Object.values(btn.PROPERTY_611)[0],
                cups: Object.values(btn.PROPERTY_613)[0],
                oldCups: Object.values(btn.PROPERTY_613)[0],
              });
            }
          } else {
            item.btns = [];
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    filterMachine(item, queryText) {
      if (item.PROPERTY_133) {
        return (
          item.NAME.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
          String(Object.values(item.PROPERTY_133))
            .toLowerCase()
            .indexOf(queryText.toLowerCase()) > -1
        );
      } else {
        return item.NAME.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
      }
    },
    async getRecipes() {
      try {
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: 145,
          start: 0,
          auth: this.auth.ACCESS_TOKEN,
        };
        let isTrue = true;
        while (isTrue) {
          const list = await axios.post(this.url + "lists.element.get", params);
          this.recipes.push(...list.data.result);
          if (list.data.next) params.start = list.data.next;
          else isTrue = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getEquips() {
      try {
        this.equips = [];
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: 143,
          start: 0,
          auth: this.auth.ACCESS_TOKEN,
        };
        let isTrue = true;
        const stocks = [
          { id: 219, name: "Тольятти" },
          { id: 227, name: "Самара" },
          { id: 229, name: "Оренбург" },
          { id: 231, name: "Ульяновск" },
          { id: 233, name: "Нижний Новгород" },
        ];
        while (isTrue) {
          const list = await axios.post(this.url + "lists.element.get", params);
          for (const equip of list.data.result) {
            const title = equip.NAME;
            const serial = equip.PROPERTY_659
              ? Object.values(equip.PROPERTY_659)[0]
              : "";
            const stock = equip.PROPERTY_643
              ? stocks.filter(
                  (e) => e.id == Object.values(equip.PROPERTY_643)[0]
                )[0].name
              : "";
            this.equips.push({
              TITLE: `${title}/${serial}/${stock}`,
              ID: equip.ID,
              serial,
              title,
              stock,
              isNew: false,
              count: equip.PROPERTY_641
                ? Object.values(equip.PROPERTY_641)[0]
                : 0,
              status: equip.PROPERTY_655
                ? Object.values(equip.PROPERTY_655)[0]
                : "",
            });
          }
          if (list.data.next) {
            params.start = list.data.next;
          } else {
            isTrue = false;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    getItems(items) {
      this.items = items;
    },
    selectObj(e) {
      const selectTitle = e.target.value;
      const selectObjs = this.objs.filter((e) => e.TITLE == selectTitle);
      this.items = selectObjs;
    },
    async getObjs() {
      try {
        this.loading = true;
        this.loadingValue = 0;
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        const listObjsAll = await axios.post(this.url + "crm.company.list", {
          auth: this.auth.ACCESS_TOKEN,
        });
        const length = listObjsAll.data.total;
        console.log({ length });
        let index = 0;
        for (let start = 0; start <= length + 50; start += 50) {
          console.log({ index });
          console.log(start);
          batchParams.cmd[
            index
          ] = `crm.company.list?select[0]=ID&select[1]=TITLE&select[2]=UF_CRM_1613562444155&start=${start}`;
          index += 1;
          this.loadingValue += 1;
          if (index % 50 == 0 || start >= length) {
            const batchResult = await axios.post(
              this.urlAdmin + "batch",
              batchParams
            );
            console.log({ batchResult });
            for (const elemBatchindex in batchResult.data.result.result) {
              for (const obj of batchResult.data.result.result[
                elemBatchindex
              ]) {
                this.objs.push(obj);
              }
            }
            batchParams.cmd = {};
          }
          await this.pause(50);
        }
        this.loading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async getObj() {
      //получаем точку
      const objParams = {
        IBLOCK_TYPE_ID: "lists",
        IBLOCK_ID: "151",
        ELEMENT_CODE: this.objID,
        auth: this.auth.ACCESS_TOKEN,
      };
      const objData = await axios.post(
        this.url + "lists.element.get",
        objParams
      );
      if (objData.data.result.length > 0) {
        const item = {
          id: objData.data.result[0].ID,
          objID: this.objID,
          objName: this.objs.filter((e) => e.ID == this.objID)[0].TITLE,
          action: this.selectAction,
          machineID: objData.data.result[0].PROPERTY_607
            ? Object.values(objData.data.result[0].PROPERTY_607)[0]
            : "",
          equips: [],
          btns: [],
          newObjID: "",
          machineSerial: "",
          machineModel: "",
          machineBrand: "",
          disabled: true,
        };
        if (item.machineID) {
          //получаем информацию об установленной машине
          await this.getMachine(item);
          //получаем информацию о кнопках
          const batchParams = {
            halt: 0,
            cmd: {},
            auth: this.auth.ACCESS_TOKEN,
          };
          if (objData.data.result[0].PROPERTY_617) {
            const btns = Object.values(objData.data.result[0].PROPERTY_617);
            for (const btnIndex in btns) {
              if (btns[btnIndex] > 0) {
                batchParams.cmd[
                  `btn_${btnIndex}`
                ] = `lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=153&ELEMENT_ID=${btns[btnIndex]}`;
                if (btnIndex > 49 || btnIndex == Number(btns.length) - 1) {
                  const batchResult = await axios.post(
                    this.urlAdmin + "batch",
                    batchParams
                  );
                  batchParams.cmd = {};
                  const batchRes = batchResult.data.result.result;
                  for (const elemBatchIndex in batchRes) {
                    item.btns.push({
                      id: batchRes[elemBatchIndex][0].ID,
                      number: batchRes[elemBatchIndex][0].PROPERTY_609
                        ? Object.values(
                            batchRes[elemBatchIndex][0].PROPERTY_609
                          )[0]
                        : "",
                      recipeID: batchRes[elemBatchIndex][0].PROPERTY_611
                        ? Object.values(
                            batchRes[elemBatchIndex][0].PROPERTY_611
                          )[0]
                        : "",
                      cups: batchRes[elemBatchIndex][0].PROPERTY_613
                        ? Object.values(
                            batchRes[elemBatchIndex][0].PROPERTY_613
                          )[0]
                        : "",
                      oldCups: batchRes[elemBatchIndex][0].PROPERTY_613
                        ? Object.values(
                            batchRes[elemBatchIndex][0].PROPERTY_613
                          )[0]
                        : "",
                    });
                  }
                }
              }
            }
          }
        }
        //получаем информацию о доп. оборудовании
        if (objData.data.result[0].PROPERTY_619) {
          //получаем информацию об установленном доп. оборудовании
          const paramsEquips = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: 165,
            FILTER: {
              PROPERTY_663: objData.data.result[0].ID,
            },
            auth: this.auth.ACCESS_TOKEN,
          };
          const ResEquips = await axios.post(
            this.url + "lists.element.get",
            paramsEquips
          );

          for (const elem of ResEquips.data.result) {
            const id = elem.CODE.split("/")[0];
            item.equips.push({
              ID: id,
              newID: "",
              newObjID: "",
              count: elem.PROPERTY_661
                ? Object.values(elem.PROPERTY_661)[0]
                : 0,
              isNew: false,
              min: elem.PROPERTY_661 ? Object.values(elem.PROPERTY_661)[0] : 0,
            });
          }
        }
        //сохраняем точку
        this.item = item;
      }
    },
  },
  watch: {
    objID: async function (newObj) {
      const params = {
        IBLOCK_TYPE_ID: "lists",
        IBLOCK_ID: 151,
        FILTER: {
          PROPERTY_605: newObj,
        },
        auth: this.auth.ACCESS_TOKEN,
      };
      const obj = await axios.post(this.url + "lists.element.get", params);
      if (obj.data.result.length > 0) {
        this.getObj();
      }
    },
  },
  async mounted() {
    this.loadingStart = true;
     const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    this.url = `https://${this.auth.DOMAIN}/rest/`;
    this.domen = this.auth.DOMAIN;

    await this.getMachines();
    await this.getRecipes();
    await this.getEquips();
    this.loadingStart = false;
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
